<template>
  <ReassuranceItems
    v-if="productResponse && selectedOffer"
    :carrier="productResponse.carrier"
    class="mt-24"
    :shipping="selectedOffer.shipping"
    :show-express-replacement
    :show-obsolete-devices="productResponse.showObsoleteDevices"
    :show-verified-refurbished="
      productResponse.showVerifiedRefurbished && !showExpressReplacement
    "
    :warranty-delay="selectedOffer.defaultWarrantyDelay"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { EXPRESS_REPLACEMENT_CATEGORIES } from '~/scopes/product/constants'
import ReassuranceItems from '~/scopes/product-core/components/presentationals/ReassuranceItems/ReassuranceItems.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: productResponse } = useFetchProduct()
const { selectedOffer } = useFetchPickers()

const marketPlace = useMarketplace()
const experiments = useExperiments()

// <!-- // TODO by category -->
const showExpressReplacement = computed(() => {
  return (
    experiments['experiment.ppExpressReplacement'] ===
      'withExpressReplacement' &&
    marketPlace.market.countryCode === MarketCountryCode.FR &&
    productResponse.value?.tracking.categoryId !== undefined &&
    EXPRESS_REPLACEMENT_CATEGORIES.includes(
      productResponse.value?.tracking.categoryId,
    )
  )
})
</script>
